
  const contractQuery = "<div><p :style=\"{'font-size':'.875rem','font-weight':400,'font-family': 'PingFang SC'}\">\n" +
    "    {{ title }}</p>\n" +
    "    <p style=\"font-size: .6875rem;margin: 5px 0;opacity: .5;font-family: 'PingFang SC'\">\n" +
    "    {{ desc }}</p></div>";


  const contractQueryV2 = "<div><p :style=\"{'font-size':'.875rem','font-weight':400,'font-family': 'PingFang SC'}\">\n" +
    "      <span v-for=\"(item,index) in title\"><a href='javascript:void;' class=\"segmentation_line\" v-if=\"index\" style=\"color: #000;\n" +
    "    opacity: 0.5;\n" +
    "    padding: 0 .3rem;\">|</a>{{item}}</span>\n" +
    "    </p>\n" +
    "    <p style=\"font-size: .6875rem;margin: 5px 0;opacity: .6;font-family: 'PingFang SC'\">\n" +
    "      <span v-for=\"(item,index) in desc\"><a href='javascript:void;' class=\"segmentation_line\" v-if=\"index && item\" style=\"color: #000;\n" +
    "    opacity: 0.5;\n" +
    "    padding: 0 .3rem;\">|</a><template v-if='index === 2'><div-span :dictItemCode=\"item\" dictCode=\"storageType\"></div-span></template><template v-else>{{item}}</template></span>\n" +
    "    </p></div>";
const orderTitle=`
  <div>
  <p style="font-size: 16px;color: #333333">
  <span v-for="(item,index) in title">
  <span class="segmentation_line" v-if="index" style="color: #cccccc">|</span>{{item}}
</span>
</p>
<p style="font-size: 11px;color: #999999">
  <span v-for="(item,index) in desc">
  <span class="segmentation_line" v-if="index" style="color: #cccccc">|</span>{{item}}
</span>
</p>
</div>
`
  const supplierQuery = "<div><p style=\"font-size: 1.1rem;font-weight:400;font-family: 'PingFang SC'\">\n" +
    "      <span v-for=\"(item,index) in title\"><a href='javascript:void;' class=\"segmentation_line\" v-if=\"index\" style=\"color: #000;\n" +
    "    opacity: 0.5;\n" +
    "    padding: 0 .3rem;\">|</a>{{item}}</span>\n" +
    "    </p>\n" +
    "    <p style=\"font-size: .6875rem;font-size: .8rem;margin: .5rem 0px 0;opacity: .5;font-family: 'PingFang SC'\">\n" +
    "      <span v-for=\"(item,index) in desc\"><a href='javascript:void;' class=\"segmentation_line\" v-if=\"index\" style=\"color: #000;\n" +
    "    opacity: 0.5;\n" +
    "    padding: 0 .3rem;\">|</a>{{item}}</span>\n" +
    "    </p></div>";

  const contractQueryV3 = "<div><p style=\"font-size: .875rem;font-weight:400;font-family: 'PingFang SC'\">\n" +
    "      <span v-for=\"(item,index) in title\"><a href='javascript:void;' class=\"segmentation_line\" v-if=\"index\" style=\"color: #000;\n" +
    "    opacity: 0.5;\n" +
    "    padding: 0 .3rem;\">|</a>{{item}}</span>\n" +
    "    </p></div>";

  const sourceQuery = "<div><p style=\"font-size: .875rem;font-weight:400;font-family: 'PingFang SC';\">\n" +
    "      <span v-for=\"(item,index) in content\" style=\"display: flex;width:80%;font-size: .8rem;\n" +
    "    line-height: 1.5rem;\"><span style=\"display: flex;\n" +
    "    font-size: .8rem;\n" +
    "    line-height: 1.5rem;\"><span style=\"display: block;\n" +
    "    width: 1.5rem;\n" +
    "    height: 1.5rem;\n" +
    "    background-color: #409eff;\n" +
    "    border-radius: .8rem;\n" +
    "    text-align: center;\n" +
    "    line-height: 1.5rem;\n" +
    "    margin-right: .5rem;\"><i :class=\"[item.icon]\" v-if=\"item.icon\" style=\"font-size: .725rem;margin-right: .2rem;margin: auto;color: #fff;\"></i></span></span><a href='javascript:void;' class=\"segmentation_line\" v-if=\"index\" style=\"color: #000;\n" +
    "    opacity: 0.5;\n" +
    "    padding: 0 .3rem;\">|</a>{{item.label}}</span>\n" +
    "    </p>\n" +
    "    <p style=\"font-size: .6875rem;font-size: 0.75rem;margin: 5px 0;opacity: .5;font-family: 'PingFang SC'\">\n" +
    "      <span v-for=\"(item,index) in desc\"><a href='javascript:void;' class=\"segmentation_line\" v-if=\"index\" style=\"color: #000;\n" +
    "    opacity: 0.5;\n" +
    "    padding: 0 .3rem;\">|</a>{{item}}</span>\n" +
    "    </p></div>";

  const complaint = "<div><p style=\"font-size: .875rem;font-weight:400;font-family: 'PingFang SC'\">\n" +
    "      <span v-for=\"(item,index) in title\"><a href='javascript:void;' class=\"segmentation_line\" v-if=\"index\" style=\"color: #000;\n" +
    "    opacity: 0.5;\n" +
    "    padding: 0 .3rem;\">-</a>{{item}}</span>\n" +
    "    </p></div>";

  const contractStatus = "<div class=\"approval_block\" v-if=\"status\"><span v-if=\"status\">\n" +
    "              <span class=\"bg_default\" v-if=\"status === 'send'\">\n" +
    "                <badge class=\"default\"></badge>草稿\n" +
    "              </span>\n" +
    "              <span class=\"bg_default\" v-else-if=\"status === 'check'\">\n" +
    "                <badge class=\"going\"></badge>审批中\n" +
    "              </span>\n" +
    "              <span class=\"bg_default\" v-else-if=\"status === 'confirm'\">\n" +
    "                <badge class=\"going\"></badge>供应商确认中\n" +
    "              </span>\n" +
    "              <span class=\"bg_default\" v-else-if=\"status === 'over'\">\n" +
    "                <badge class=\"success\"></badge>已发布\n" +
    "              </span>\n" +
    "              <span class=\"bg_default\" v-else-if=\"status === 'end'\">\n" +
    "                <badge class=\"success\"></badge>已结束\n" +
    "              </span>\n" +
    "              <span class=\"bg_default\" v-else-if=\"status === 'delete'\">\n" +
    "                <badge class=\"error\"></badge>已作废\n" +
    "              </span>\n" +
    "            </span></div>";
  const asnStatus = "<div class=\"approval_block\" v-if=\"status\"><span v-if=\"status\">\n" +
    "              <span class=\"bg_default\" v-if=\"status === 'DRAFT'\">\n" +
    "                <badge class=\"default\"></badge>制单中\n" +
    "              </span>\n" +
    "              <span class=\"bg_default\" v-else-if=\"status === 'TO_BE_DELIVERED'\">\n" +
    "                <badge class=\"going\"></badge>待发货\n" +
    "              </span>\n" +
    "              <span class=\"bg_default\" v-else-if=\"status === 'TO_BE_RECEIVED'\">\n" +
    "                <badge class=\"going\"></badge>已发货\n" +
    "              </span>\n" +
    "            </span></div>";
  const cargoStatus = "<div class=\"approval_block\" v-if=\"status\"><span v-if=\"status\">\n" +
    "              <span class=\"bg_default\" v-if=\"status === 'draft'\">\n" +
    "                <badge class=\"default\"></badge>草稿\n" +
    "              </span>\n" +
    "              <span class=\"bg_default\" v-else-if=\"status === 'confirming'\">\n" +
    "                <badge class=\"going\"></badge>待确认订单\n" +
    "              </span>\n" +
    "              <span class=\"bg_default\" v-else-if=\"status === 'confirmed'\">\n" +
    "                <badge class=\"going\"></badge>已完成\n" +
    "              </span>\n" +
    "            </span></div>";
  const orderStatus = "<div class=\"approval_block\" v-if=\"status\"><span v-if=\"status\">\n" +
    "              <span class=\"bg_default\" v-if=\"status === '0'\">\n" +
    "                <badge class=\"default\"></badge>未发布\n" +
    "              </span>\n" +
    "              <span class=\"bg_default\" v-else-if=\"status === '1'\">\n" +
    "                <badge class=\"going\"></badge>供应商确认中\n" +
    "              </span>\n" +
    "              <span class=\"bg_default\" v-else-if=\"status === '2'\">\n" +
    "                <badge class=\"going\"></badge>供应商已确认\n" +
    "              </span>\n" +
    "              <span class=\"bg_default\" v-else-if=\"status === '3'\">\n" +
    "                <badge class=\"going\"></badge>待送货\n" +
    "              </span>\n" +
    "              <span class=\"bg_default\" v-else-if=\"status === '4'\">\n" +
    "                <badge class=\"going\"></badge>送货中\n" +
    "              </span>\n" +
    "              <span class=\"bg_default\" v-else-if=\"status === '5'\">\n" +
    "                <badge class=\"going\"></badge>完成收货\n" +
    "              </span>\n" +
    "              <span class=\"bg_default\" v-else-if=\"status === '6'\">\n" +
    "                <badge class=\"going\"></badge>已作废\n" +
    "              </span>\n" +
    "            </span></div>";

  const supplierModifyStatus = "<div class=\"approval_block\" v-if=\"status\"><span v-if=\"status\">\n" +
    "              <span class=\"bg_default\">\n" +
    "                {{status}}\n" +
    "              </span>\n" +
    "            </span></div>"


  const supplierRatingStatus = "<div class=\"approval_block\" v-if=\"status\"><span v-if=\"status\">\n" +
    "              <span class=\"bg_default\" v-if=\"status === 'send'\">\n" +
    "                <badge class=\"default\"></badge>发起\n" +
    "              </span>\n" +
    "              <span class=\"bg_default\" v-else-if=\"status === 'examine'\">\n" +
    "                <badge class=\"going\"></badge>采购总监审批\n" +
    "              </span>\n" +
    "              <span class=\"bg_default\" v-else-if=\"status === 'confirm'\">\n" +
    "                <badge class=\"going\"></badge>供应商确认中\n" +
    "              </span>\n" +
    "              <span class=\"bg_default\" v-else-if=\"status === 'end'\">\n" +
    "                <badge class=\"success\"></badge>成功\n" +
    "              </span>\n" +
    "              <span class=\"bg_default\" v-else-if=\"status === 'fail'\">\n" +
    "                <badge class=\"error\"></badge>失败\n" +
    "              </span>\n" +
    "            </span></div>";

  const sourceStatus =`
  <div class="approval_block_none_bg" style="color: rgb(64, 158, 255);" v-if="status"><span v-if="status">
              <span class="bg_default" v-if="status === 'NEW'">
                新建/立项
              </span>
              <span class="bg_default" v-else-if="status === 'ENROLL'">
                报名/预审
              </span>
              <span class="bg_default" v-else-if="status === 'OFFER'">
                报价/投标
              </span>
              <span class="bg_default" v-else-if="status === 'RATING'">
                评比/评标
              </span>
              <span class="bg_default" v-else-if="status === 'AWARD'">
                定价/决标
              </span>
              <span class="bg_default" v-else-if="status === 'SUSPEND'">
                中止
              </span>
              <span class="bg_default" v-else-if="status === 'FINISH'">
                结束
              </span>
            </span></div>
  `
  const sourceRound = "<span class=\"black opacity7 block_content font_dot8\">" +
    "<p><i class=\"fa fa-file-text-o font-size-mr\" style=\"font-size: .725rem;margin-right: .2rem;margin: auto;color: #606266;padding: 0 .3rem;\"></i>轮次</p>" +
    "<p style=\"padding: .4rem 0 0;color: #000;\">" +
    "<span v-if=\"currentRound == 1\">第一轮</span>\n" +
    "<span v-else-if=\"currentRound == 2\">第二轮</span>\n" +
    "<span v-else-if=\"currentRound == 3\">第三轮</span>" +
    "</p>" +
    "</span>";
  const sourceTakeWay = "<span class=\"black opacity7 block_content font_dot8\">" +
    "<p><i class=\"fa fa-file-text-o font-size-mr\" style=\"font-size: .725rem;margin-right: .2rem;margin: auto;color: #606266;padding: 0 .3rem;\"></i>参与方式</p>" +
    "<p style=\"padding: .4rem 0 0;color: #000;\">" +
    "<span v-if=\"sourceWay == 'INVITATION'\">邀请参与</span>\n" +
    "<span v-else-if=\"sourceWay == 'PUBLIC'\">公开参与</span>\n" +
    "</p>" +
    "</span>";

  const complaintStatus = `
  <div class="approval_block" v-if="status">
  <span class="bg_default" v-if="status=='send'">
    未提交
  </span>
  <span class="bg_default" v-else-if="status==1">
    进行中
  </span>
  <span class="bg_default" v-else-if="status==2">
    结束
  </span>
</div>
  `;

  const supplierStatus = `
  <div class="supplier_status_block" v-if="status">
  <span class="bg_default">
    {{status}}
  </span>
</div>
  `;


  const sampleStatus = `
  <div class="approval_block" v-if="status">
  <template v-if="status=='send'&& item.requestBase">
   <span class="bg_default" >
  <template v-if="item.requestBase.currentNodeType==0">
  <badge class="bg_default"></badge>未提交
</template>
  <template v-if="item.requestBase.currentNodeType==1">
  <badge class="going"></badge>发起
</template>
  </span>
</template>
  <span class="bg_default" v-else-if="status=='fail'">
    <badge class="error"></badge>流程报错
  </span>
  <span class="bg_default" v-else-if="status=='confirm'">
  <badge class="going"></badge>供应商确认
  </span>
  <span class="bg_default" v-else-if="status=='sendSample'">
  <badge class="going"></badge>供应商发货
  </span>
  <span class="bg_default" v-else-if="status=='getSample'">
  <badge class="going"></badge>样品收货
  </span>
  <span class="bg_default" v-else-if="status=='result'">
  <badge class="going"></badge>样品认证
  </span>
  <span class="bg_default" v-else-if="status=='end'">
  <badge class="success"></badge>认证结束
  </span>
</div>
  `

  const reformStatus = `
  <div class="approval_block" v-if="status">
  <span class="bg_default" v-if="status=='fail'">
    <badge class="error"></badge>失败
  </span>
  <span class="bg_default" v-else-if="status=='start'||status=='send'">
  <badge class="going"></badge>发起
  </span>
  <span class="bg_default" v-else-if="status=='reform'">
  <badge class="going"></badge>供应商整改
  </span>
  <span class="bg_default" v-else-if="status=='comfirm'">
  <badge class="going"></badge>确认整改结果
  </span>
  <span class="bg_default" v-else-if="status=='examination'||status=='examine'">
  <badge class="going"></badge>采购总监审批
  </span>
  <span class="bg_default" v-else-if="status=='end'">
  <badge class="success"></badge>成功
  </span>
</div>
  `;
  const accountStatus = `
  <div class="approval_block" >
  <span class="bg_default" v-if="status">
    <badge class="error"></badge>激活
  </span>
  <span class="bg_default" v-else>
  <badge class="success"></badge>未激活
  </span>
</div>
  `;

  const qualityTestType = "<span v-if=\"status\">\n" +
    "              <span class=\"bg_default\" v-if=\"status === 'STOCK_CHECK'\">\n" +
    "                入库检验\n" +
    "              </span>\n" +
    "              <span class=\"bg_default\" v-else-if=\"status === 'PROCESS_CHECK'\">\n" +
    "                过程检验\n" +
    "              </span>\n" +
    "              <span class=\"bg_default\" v-else-if=\"status === 'CUS_DISC'\">\n" +
    "                客户发现\n" +
    "              </span>\n" +
    "              <span class=\"bg_default\" v-else-if=\"status === 'OTHER'\">\n" +
    "                其他\n" +
    "              </span>\n" +
    "            </span>";

  const qualityStatus = "<div class=\"approval_block\" v-if=\"status\"><span v-if=\"status\">\n" +
    "              <span class=\"bg_default\" v-if=\"status === 'QUALIFIED'\">\n" +
    "                <badge class=\"going\"></badge>合格\n" +
    "              </span>\n" +
    "              <span class=\"bg_default\" v-else-if=\"status === 'CONCESSION'\">\n" +
    "                <badge class=\"going\"></badge>让步接受\n" +
    "              </span>\n" +
    "              <span class=\"bg_default\" v-else-if=\"status === 'DISQUALIFIED'\">\n" +
    "                <badge class=\"success\"></badge>不合格\n" +
    "              </span>\n" +
    "            </span></div>";

  const claimScType = "<span v-if=\"status\">\n" +
    "              <span class=\"bg_default\" v-if=\"status === '001'\">\n" +
    "                质量问题\n" +
    "              </span>\n" +
    "              <span class=\"bg_default\" v-else>\n" +
    "                其他\n" +
    "              </span>\n" +
    "            </span>";
  const priceApprovalStatus = `
  <div class="approval_block" v-if="status">
  <template v-if="status=='send'&& item.requestBase">
   <span class="bg_default" >
  <template v-if="item.requestBase.currentNodeType==0">
  <badge class="bg_default"></badge>未提交
</template>
  <template v-if="item.requestBase.currentNodeType==1">
  <badge class="going"></badge>待发起
</template>
  </span>
</template>
  <span class="bg_default" v-else-if="status=='approval'">
    <badge class="error"></badge>审批
  </span>
  <span class="bg_default" v-else-if="status=='end'">
  <badge class="going"></badge>结束
  </span>
</div>
  `
  const ratingState = `
  <div class="approval_block" v-if="status">
  <span class="bg_default" v-if="status=='fail'">
    <badge class="error"></badge>失败
  </span>
  <span class="bg_default" v-else-if="status=='send'">
  <badge class="default"></badge>发起
  </span>
  <span class="bg_default" v-else-if="status=='examine'">
  <badge class="going"></badge>采购总监审批
  </span>
  <span class="bg_default" v-else-if="status=='end'">
  <badge class="success"></badge>成功
  </span>
</div>
  `
  const scoreDealStatus = `
  <div class="approval_block" v-if="status">
  <span class="bg_default" v-if="status=='NOT_STARTED'">
    <badge class="default"></badge>未开始
  </span>
  <span class="bg_default" v-else-if="status=='ONGOING'">
  <badge class="going"></badge>评分中
  </span>
  <span class="bg_default" v-else-if="status=='FINISH'">
  <badge class="success"></badge>已评分
  </span>
</div>
  `
  const scoreNotDealStatus = `
  <div class="approval_block" v-if="status">
  <span class="bg_default" v-if="status=='unaudited'">
    <badge class="default"></badge>未审核
  </span>
  <span class="bg_default" v-else-if="status=='approval'">
  <badge class="success"></badge>已审核
  </span>
</div>
  `
  const materialQutaManageStatus = `
  <div class="approval_block fn_12" style="background: white;margin-right: 10px;">
  <div>配额数量/比例</div>
  <div style="color: #000;">{{number}}/{{rate}}%</div>
</div>
  `


  const claimStatus = "<div class=\"approval_block\" v-if=\"status\"><span v-if=\"status\">\n" +
    "              <span class=\"bg_default\" v-if=\"status === '001'\">\n" +
    "                <badge class=\"default\"></badge>未处理\n" +
    "              </span>\n" +
    "              <span class=\"bg_default\" v-else>\n" +
    "                <badge class=\"going\"></badge>完结\n" +
    "              </span>\n" +
    "            </span></div>";

  const sourcingWorkFlowDealStatus = "<div class=\"approval_block\" v-if=\"status\"><span v-if=\"status\">\n" +
    "              <span class=\"bg_default\" v-if=\"status === 'NOT_STARTED'\">\n" +
    "                <span class=\"spot bg_bfbfbf\"></span><span class=\"spot_text\"></span>未开始\n" +
    "              </span>\n" +
    "              <span class=\"bg_default\" v-if=\"status === 'GOING'\">\n" +
    "                <span class=\"spot bg_1890ff\"></span><span class=\"spot_text \"></span>进行中\n" +
    "              </span>\n" +
    "              <span class=\"bg_default\" v-if=\"status === 'PAUSE'\">\n" +
    "                <span class=\"spot bg_fadd14\"></span><span class=\"spot_text \"></span>暂停\n" +
    "              </span>\n" +
    "              <span class=\"bg_default\" v-if=\"status === 'FINISH'\">\n" +
    "                <span class=\"spot bg_52c41a\"></span><span class=\"spot_text \"></span>已结束\n" +
    "              </span>\n" +
    "            </span></div>";


  const sourceTakeWayNoneIcon=`
  <span class="black opacity7">
  <span v-if="sourceWay=='INVITATION'">邀请参与</span>
  <span v-else-if="sourceWay=='PUBLIC'">公开参与</span>
</span>
  `

  const suppliersDealStatus = "<div class=\"approval_block\" v-if=\"status\"><span v-if=\"status\">\n" +
    "              <span class=\"bg_default\" v-if=\"status === '102'\">\n" +
    "                <span class=\"spot bg_bfbfbf\"></span><span class=\"spot_text\"></span>资料未提交\n" +
    "              </span>\n" +
    "              <span class=\"bg_default\" v-if=\"status === '103'\">\n" +
    "                <span class=\"spot bg_1890ff\"></span><span class=\"spot_text \"></span>资料已提交\n" +
    "              </span>\n" +
    "              <span class=\"bg_default\" v-if=\"status === '104'\">\n" +
    "                <span class=\"spot bg_52c41a\"></span><span class=\"spot_text \"></span>审核通过\n" +
    "              </span>\n" +
    "              <span class=\"bg_default\" v-if=\"status === '105'\">\n" +
    "                <span class=\"spot bg_fadd14\"></span><span class=\"spot_text \"></span>审核退回\n" +
    "              </span>\n" +
    "              <span class=\"bg_default\" v-if=\"status === '106'\">\n" +
    "                <span class=\"spot bg_f5222d\"></span><span class=\"spot_text \"></span>审核拒绝\n" +
    "              </span>\n" +
    "            </span></div>";

  const leftImageBlock = "<div style=\"width: 4rem;height: 4rem;background-color: #f2f2f2;border-radius: .2rem;text-align: center;line-height: 5.5rem;\">" +
    "<img v-if=\"noneData\" style=\"width: 4rem;height: 4rem;border-radius: .2rem;\" :src=\"imgAddress\" alt=\"\">" +
    "<img v-else style=\"width: 2rem;height: 2rem;border-radius: .2rem;\" :src=\"imgAddress\" alt=\"\">" +
    "</div>";


  const supplierLeftBlock = "<div>\n" +
    "        <div style=\"width: 3rem;height: 3rem;background-color: #3397ff;border-radius: 2rem;color: white;\">\n" +
    "          <div style=\"width: 2rem;height: 2rem;margin: auto;text-align: center;padding:0.4rem 0px .5rem;font-size: .8rem;\">\n" +
    "          {{supplierName.substr(0,4)}}\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>";
  const supplierBusinessModel = "<span class=\"black opacity7 block_content_none_pg font_dot8\">" +
    "<p class=\"opacityDot6\"><i class=\"fa fa-calendar-check-o font-size-mr\" style=\"font-size: .725rem;margin-right: .2rem;\"></i>经营模式</p>" +
    "<p style=\"padding: .4rem 0 0;color: #000;\">" +
    "<span class=\"black opacity7\">\n" +
    "<span v-if=\"businessModel === '2'\">代理商</span>\n" +
    "<span v-else-if=\"businessModel === '1'\">制造商</span>\n" +
    "<span v-else>制造商,代理商</span>\n" +
    "</span></p>\n" +
    "</span>";

  export default {
    contractQuery,
    contractQueryV2,
    contractQueryV3,
    orderTitle,
    contractStatus,
    asnStatus,
    cargoStatus,
    orderStatus,
    supplierModifyStatus,
    supplierRatingStatus,
    sampleStatus,
    complaint,
    sourceQuery,
    sourceStatus,
    sourceRound,
    sourceTakeWay,
    complaintStatus,
    accountStatus,
    reformStatus,
    qualityTestType,
    priceApprovalStatus,
    materialQutaManageStatus,
    qualityStatus,
    claimScType,
    claimStatus,
    sourcingWorkFlowDealStatus,
    sourceTakeWayNoneIcon,
    suppliersDealStatus,
    leftImageBlock,
    scoreDealStatus,
    scoreNotDealStatus,
    ratingState,
    supplierQuery,
    supplierStatus,
    supplierLeftBlock,
    supplierBusinessModel
  }



// WEBPACK FOOTER //
// ./src/components/list-template/list-header-template.vue